;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.order.show')
    .controller('OrderShowController', OrderShowController)

  OrderShowController.$inject = [
    // Urls
    'urls',

    // Angular
    '$scope', '$http', '$state',
    '$uibModal', '$q', '$rootScope', '$timeout',

    // Managers
    'InvoiceManager', 'InvoiceLineManager', 'OrderManager', 'CreditNoteManager', 'BpuManager',

    // Services
    'PreferencesService', 'EntityService', 'DatePickerService',
    'UtilService', 'StatusService', 'SnackService',
    'LineService', 'ReferersService', 'ComputingService',
    'RubricService', 'InvoiceService', 'DisplayService', 'SessionService',

    // Resolve
    'order', 'initParams', 'customFields', 'vats', 'generalPrefs'

  ]

  function OrderShowController (
    // Urls
    urls,

    // Angular
    $scope, $http, $state,
    $uibModal, $q, $rootScope, $timeout,

    // Managers
    InvoiceManager, InvoiceLineManager, OrderManager, CreditNoteManager, BpuManager,

    // Services
    PreferencesService, EntityService, DatePickerService,
    UtilService, StatusService, SnackService,
    LineService, ReferersService, ComputingService,
    RubricService, InvoiceService, DisplayService, SessionService,

    // Resolve
    order, initParams, customFields, vats, generalPrefs

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        active: 0,
        order: order,
        customFields: _.sortBy(customFields, function (c) {
          return c.options.index
        }),
        bpus: [],
        displayActivity: !!_.get(generalPrefs, 'settings.edition.displayActivity', false), // double inverse to debind from generalPrefs
        // Methods
        selectEntity: selectEntity,
        deleteEntity: deleteEntity,
        save: save,
        addLine: addLine,
        getTotal: getTotal,
        getVATs: getVATs,
        getFullTotal: getFullTotal,
        getOrderNumber: getOrderNumber,
        getInvoiceNumber: getInvoiceNumber,
        addTitle: addTitle,
        addRubric: addRubric,
        editTitle: editTitle,
        dropLine: dropLine,
        removeLine: removeLine,
        editLine: editLine,
        editAmendment: editAmendment,
        asPdf: asPdf,
        /* asCsv: asCsv,
        asSpreadsheet: asSpreadsheet, */
        isValid: isValid,
        isDraft: isDraft,
        setStartDate: setStartDate,
        setDueDate: setDueDate,
        resetStartDate: resetStartDate,
        resetDueDate: resetDueDate,
        changeDueDate: changeDueDate,
        duplicateOrder: duplicateOrder,
        toggleEditionMode: toggleEditionMode,
        containsDiscount: containsDiscount,
        amendmentsContainsDiscount: amendmentsContainsDiscount,
        getDiscountAmount: getDiscountAmount,
        getDiscountedTotal: getDiscountedTotal,
        getOrderDiscountedTotal: getOrderDiscountedTotal,
        getTotalDiscount: getTotalDiscount,
        setStatus: setStatus,
        selectReferers: selectReferers,
        getPositionLabel: getPositionLabel,
        getLinesFor: getLinesFor,
        lineToFlateRate: lineToFlateRate,
        getLastProgress: getLastProgress,
        getLineRealTotal: getLineRealTotal,
        getLineTotalProgress: getLineTotalProgress,
        getMaxAllowedProgress: getMaxAllowedProgress,
        getSituationSummary: getSituationSummary,
        getSituationExVat: getSituationExVat,
        getSituationFullTotal: getSituationFullTotal,
        addAmendment: addAmendment,
        removeAmendment: removeAmendment,
        modifyPayment: modifyPayment,
        goToCreditNoteId: goToCreditNoteId,
        select: select,
        enableNumberEdit: enableNumberEdit,
        enableOrderNumberEdit: enableOrderNumberEdit,
        disableNumberEdit: disableNumberEdit,
        isAdmin: isAdmin,
        canEdit: canEdit,
        searchBpu: searchBpu,
        getVatList: getVatList
      })
      init()
    }

    if (initParams && !angular.equals({}, initParams)) {
      var params = angular.copy(initParams)
      if (!initParams.toCreate) {
        $scope.$watch(function () {
          return self['invoiceForm_' + params.objIndex]
        }, function () {
          self.select(params.obj, params.objIndex)
          initParams = undefined
        })
      }
    }
    if ((!initParams || angular.equals({}, initParams)) || initParams.toCreate) {
      $scope.$watch(function () {
        return self.theForm
      }, function () {
        self.select(self.order)
        if (initParams.toCreate && self.theForm) self.theForm.$dirty = true
      })
    }

    $rootScope.$on('newSituation', createSituation)

    $scope.$on('formModified', function () {
      self.selectedForm.$dirty = true
    })

    function init () {
      if (initParams && !angular.equals({}, initParams)) initActiveObject()
      initOrder()
      PreferencesService.getPrefsFor('order').then(function (prefs) {
        self.prefs = prefs
        self.logo = urls.downloader + '/object/' + _.get(prefs, 'companyInfo.logo._id')
      })
      setEditable()
      if (!self.selectedObj) selectOrder()
      getDiscounts()
      getVATs()
      setDates()
    }

    function isAdmin () {
      return SessionService.isAdmin()
    }

    function canEdit () {
      return SessionService.isAdmin() || SessionService.isValidator()
    }

    function selectOrder () {
      self.selectedObj = self.order
      self.selectedObj.type = 'order'
      self.select(self.order)
    }

    function setEditable () {
      self.editable = self.order.status === 'draft'
      if (!self.editable) {
        self.editMode = self.editMode || false
      }
    }

    function initOrder () {
      setInvoicesDates()
      self.order.type = 'order'
      self.order.invoices = self.order.invoices || []
      self.orderInvoices = angular.copy(self.order.invoices)
      initInvoiceIndexes()
      self.customFields = self.customFields || []
      self.order.rubrics = self.order.rubrics || []
      if (self.order.rubrics && self.order.rubrics.length) {
        self.order.rubrics = _.flattenDeep(RubricService.sortRubrics(self.order.rubrics))
      }
      self.order.amendments = self.order.amendments || []
      self.order.referers = self.order.referers || []
      self.order.tags = self.order.tags || []
      self.order.customFields = self.order.customFields || {}
    }

    function initActiveObject () {
      if (params.toCreate) {
        self.order = OrderManager.create(params.toCreate)
        self.select(self.order)
      } else {
        self.active = params.tabIndex
        if (params.obj.date) params.obj.date = new Date(params.obj.date)
        if (params.obj.dueDate) params.obj.dueDate = new Date(params.obj.dueDate)
        self.selectedObj = params.obj
        self.selectedObj.type = 'situation'
        self.select(params.obj, params.objIndex)
      }
    }

    function initInvoiceIndexes () {
      _.each(self.orderInvoices, function (elt, index) {
        if (typeof elt === 'string') return
        elt.index = self.orderInvoices.length - index
      })
    }

    function goToCreditNoteId (creditNoteId) {
      $state.go('creditnote.show', { id: creditNoteId })
    }

    function getMaxAllowedProgress (line) {
      return (100 - line.lastProgression)
    }

    function isProgressValid (line) {
      return (line.progression !== null) && !isNaN(line.progression) &&
        (line.progression >= 0) &&
        (line.progression <= getMaxAllowedProgress(line))
    }

    function getLineTotalProgress (line) {
      if (!isProgressValid(line)) {
        line.totalProgression = 0
        line.valid = false
      } else {
        line.totalProgression = line.lastProgression + line.progression
        line.valid = true
      }
      getSituationVATs()
      self.selectedForm.$dirty = true
    }

    function initProgress (line) {
      if (!isProgressValid(line)) {
        line.totalProgression = 0
        line.valid = false
      } else {
        line.valid = true
      }
    }

    function setInvoicesDates () {
      if (self.order.invoices) {
        _.each(self.order.invoices, function (invoice) {
          if (invoice.date) invoice.date = new Date(invoice.date)
          if (invoice.dueDate) invoice.dueDate = new Date(invoice.dueDate)
        })
      }
    }

    function setSelectedForm () {
      if (self.selectedObj.type === 'order') {
        self.selectedForm = self.theForm
      } else {
        if (self.selectedObj.hasOwnProperty('index')) {
          self.selectedForm = self['invoiceForm_' + self.selectedObj.index]
        }
      }
    }

    function select (obj, index) {
      self.selectedObj = obj
      self.selectedObj.status = self.selectedObj.status || 'draft'
      self.selectedObj.customFields = self.selectedObj.customFields || {}
      if (index !== undefined) {
        self.selectedObj.index = index
      }
      setSelectedForm()
      self.availableStatus = StatusService.getAllowedStatus(self.selectedObj.type === 'situation' ? 'invoice' : self.selectedObj.type, self.selectedObj.status)
      if (self.selectedObj.type === 'situation') {
        _.each(self.selectedObj.lines, function (line) {
          initProgress(line)
        })
        getSituationVATs()
      }
      self.editable = self.selectedObj.status === 'draft'
      getVATs()
      if (
        self.selectedObj.type === 'situation' &&
        self.selectedObj.balanceDue >= 0 &&
        self.selectedObj.status !== 'paid' &&
        self.selectedObj.status !== 'draft'
      ) {
        payInvoice()
      }
    }

    function enableOrderNumberEdit () {
      var content = 'Vous êtes sur le point de changer le numéro de ce chantier.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Modifier le numéro', content).then(function () {
        self.editNumber = true
        $timeout(function () {
          document.getElementById('orderNumberEdit').focus() // DJIKERY C MAL
        })
      })
    }

    function enableNumberEdit () {
      var content = 'Vous êtes sur le point de changer le numéro de cette facture.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Modifier le numéro', content).then(function () {
        self.editNumber = true
        $timeout(function () {
          document.getElementById('numberEdit').focus() // DJIKERY C MAL
        })
      })
    }

    function disableNumberEdit () {
      self.editNumber = false
    }

    function selectReferers () {
      ReferersService.promptSelection(self.selectedObj.referers)
        .then(function (referers) {
          self.selectedObj.referers = referers
          self.selectedForm.$dirty = true
        })
    }

    function initNewLinesProgress (lines) {
      _.each(lines, function (line, index) {
        line.lastProgression = getLastProgress(index)
        line.progression = 0
        line.totalProgression = line.lastProgression + line.progression
        line.valid = true
      })
    }

    function createLinesFromOrder () {
      var lines = []
      if (!self.order.rubrics || !self.order.rubrics.length) {
        createFromLinesOnly(lines)
      } else {
        createFromRubrics(lines)
      }
      applyAmendments(lines)
      initNewLinesProgress(lines)
      return lines
    }

    function applyAmendments (lines) {
      if (self.order.amendments && self.order.amendments.length) {
        _.each(self.order.amendments, function (line) {
          line.type = 'situation'
        })
        lines.push.apply(lines, self.order.amendments)
      }
    }

    function createFromLinesOnly (lines) {
      _.each(self.order.lines, function (line) {
        var newLine = InvoiceLineManager.create(line.clone())
        newLine.type = 'situation'
        lines.unshift(newLine)
      })
    }

    function createFromRubrics (lines) {
      _.each(self.order.rubrics, function (rubric) {
        var label = '' + getPositionLabel(rubric) + ' - ' + rubric.label
        var title = InvoiceLineManager.create({ label: label, type: 'label' })
        lines.push(title)
        var products = angular.copy(getLinesFor(rubric))
        if (products && products.length) {
          _.each(products, function (elt) {
            elt.type = 'situation'
          })
          lines.push.apply(lines, products)
        }
      })
    }

    function createSituation () {
      self.loading = true
      InvoiceService.createInvoiceFromPreferences()
        .then(function (newInvoice) {
          newInvoice.client = self.order.client
          newInvoice.type = 'situation'
          self.orderInvoices = self.orderInvoices || []
          self.orderInvoices.unshift(newInvoice)
          newInvoice.lines = createLinesFromOrder()
          $timeout(function () {
            self.active = 1
            select(newInvoice, self.orderInvoices.length)
            self.loading = false
          })
        })
    }

    function amendmentsContainsDiscount () {
      if (!self.order.amendments || !self.order.amendments.length) { return false }
      return !!_.filter(self.order.amendments, function (elt) {
        return elt.discount
      }).length
    }

    function getTotalDiscount () {
      return ComputingService.getTotalDiscount(self.discounts)
    }

    function containsDiscount () {
      return ComputingService.containsDiscount(self.order)
    }

    function getDiscountAmount (line) {
      return ComputingService.getDiscountAmount(line)
    }

    function getDiscountedTotal (line) {
      return ComputingService.getDiscountedTotal(line)
    }

    function getDiscounts () {
      self.discounts = ComputingService.getDiscounts(self.order.lines)
    }

    /**
     * EX-VAT Total
     */
    function getTotal () {
      return ComputingService.getTotal(self.order.lines)
    }

    function getSituationSummary () {
      return _.reduce(self.selectedObj.lines, function (acc, line) {
        if (line.type === 'label') return acc
        return Math.round(acc + getLineRealTotal(line))
      }, 0)
    }

    function getSituationExVat (invoice) {
      return _.reduce(invoice.lines, function (acc, line) {
        if (line.type === 'label') return acc
        return Math.round(acc + getLineCurrentTotal(line))
      }, 0)
    }

    function getSituationFullTotal () {
      return getSituationExVat(self.selectedObj) + _.reduce(self.situationVats, function (acc, vat) {
        return Math.round(acc + vat.amount)
      }, 0)
    }

    function getSituationVATs () {
      self.situationVats = self.selectedObj.situationCurrentVATInfo
    }

    function getLineRealTotal (line) {
      return Math.round(((line.total - (line.discountAmount || 0)) * line.totalProgression) / 100)
    }

    function getLineCurrentTotal (line) {
      return Math.round(((line.total - (line.discountAmount || 0)) * line.progression) / 100)
    }

    function getLastProgress (lineIndex) {
      if (self.order.currentInvoice && self.order.currentInvoice.lines && self.order.currentInvoice.lines[lineIndex]) {
        return self.order.currentInvoice.lines[lineIndex].totalProgression
      }
      return 0
    }

    /**
     * Sets self.vats to a collection containing 'amount' and 'VAT'
     */
    function getVATs () {
      self.vats = ComputingService.getVATs(self.selectedObj.lines)
    }

    function getOrderDiscountedTotal () {
      return ComputingService.getObjectDiscountedTotal(self.selectedObj.lines)
    }

    function getFullTotal () {
      return ComputingService.getFullTotal(self.selectedObj.lines, self.vats)
    }

    function toggleEditionMode () {
      self.editMode = !self.editMode
    }

    function duplicateOrder () {
      PreferencesService.getPrefsFor('order').then(function (prefs) {
        var order = OrderManager.create(self.order.duplicate())
        if (self.order.client && self.order.client.paymentDelay) {
          order.dueDate = moment(new Date()).add(self.order.client.paymentDelay, 'days').toDate()
        } else {
          order.dueDate = moment(new Date()).add(prefs.orderDelay, 'days').toDate()
        }
        $state.go('order.new', {
          initParams: {
            toCreate: order
          }
        })
        SnackService.snack({
          text: 'Chantier dupliqué !',
          delay: 5000
        })
      })
    }

    function switchToStatus (status) {
      if (initParams && !angular.equals({}, initParams)) {
        initParams = undefined
        params = undefined
      }
      self.selectedObj.history = self.selectedObj.history || []
      self.selectedObj.history.push({ status: self.selectedObj.status, date: new Date() })
      self.selectedObj.status = status
      if (self.selectedObj.status === 'validated' || self.selectedObj.status === 'in_progress') {
        if (self.selectedObj.type === 'situation') {
          PreferencesService.getInvoicePrefs().then(validateAndRedirect)
        } else {
          PreferencesService.getOrderPrefs().then(validateAndRedirect)
        }
      } else {
        return self.selectedObj.save().then(function () {
          self.loading = false
          redirect()
          init()
        })
      }
    }

    function postValidate () {
      self.loading = false
      redirect()
      init()
    }

    function validateAndRedirect (prefs) {
      self.selectedObj.periodicity = prefs.periodicity
      self.selectedObj.resetDate = prefs.resetDate
      self.selectedObj.numberFormat = prefs.numberFormat
      if (!self.selectedObj.date) self.selectedObj.date = new Date()
      if (!self.selectedObj.dueDate) {
        changeDueDate().then(function () {
          return self.selectedObj.validate().then(postValidate)
        })
      } else {
        return self.selectedObj.validate().then(postValidate)
      }
    }

    function redirect () {
      if (self.selectedObj.type === 'situation') {
        $state.go('order.show', {
          id: self.order._id,
          initParams: {
            tabIndex: self.active,
            objIndex: self.selectedObj.index,
            obj: self.selectedObj
          }
        })
      } else {
        $state.reload()
      }
    }

    function changeDueDate () {
      var type = self.selectedObj.type === 'situation' ? 'invoice' : 'order'
      return PreferencesService.getPrefsFor(type).then(function (prefs) {
        if (self.selectedObj.client && self.selectedObj.client.paymentDelay) {
          self.selectedObj.dueDate = moment(self.selectedObj.date).add(self.selectedObj.client.paymentDelay, 'days').toDate()
        } else {
          self.selectedObj.dueDate = moment(self.selectedObj.date).add(prefs[type + 'Delay'], 'days').toDate()
        }
        self.selectedForm.$dirty = true
      })
    }

    function setStartDate () {
      if (!self.editable) return
      var opt = (self.selectedObj.dueDate) ? { maxDate: self.selectedObj.dueDate } : undefined
      DatePickerService.getRange(self.selectedObj.date, opt).then(function (date) {
        self.selectedObj.date = new Date(date)
        self.selectedForm.$dirty = true
        changeDueDate()
      })
    }

    function resetStartDate () {
      self.selectedObj.date = null
      self.selectedForm.$dirty = true
    }

    function setDueDate () {
      if (!self.editable) return
      var opt = (self.selectedObj.date) ? { minDate: self.selectedObj.date } : undefined
      DatePickerService.getRange(self.selectedObj.dueDate, opt).then(function (date) {
        self.selectedObj.dueDate = new Date(date)
        self.selectedForm.$dirty = true
      })
    }

    function resetDueDate () {
      self.selectedObj.dueDate = null
      self.selectedForm.$dirty = true
    }

    function setDates () {
      if (self.order.date && self.order.status !== 'draft') self.order.date = new Date(self.order.date)
      else {
        self.order.date = new Date()
        PreferencesService.getPrefsFor('order').then(function (prefs) {
          if (self.order.client && self.order.client.paymentDelay) {
            self.order.dueDate = moment(self.order.date).add(self.order.client.paymentDelay, 'days').toDate()
          } else {
            self.order.dueDate = moment(self.order.date).add(prefs.orderDelay, 'days').toDate()
          }
        })
      }
      if (self.order.dueDate) self.order.dueDate = new Date(self.order.dueDate)
    }

    function selectEntity () {
      var config = {
        title: 'Sélectionner Client',
        headerAction: 'Créer un nouveau client',
        accessibleTypes: ['Organization', 'Agency', 'professional', 'individual']
      }
      EntityService.prompt(config).then(function (entity) {
        self.selectedObj.client = entity
        changeDueDate()
        self.theForm.$dirty = true
      })
    }

    function deleteEntity () {
      self.selectedObj.client = null
      self.theForm.$dirty = true
    }

    function addLine () {
      return LineService.promptLineCreate(self.order)
        .then(function (res) {
          self.order.lines = self.order.lines || []
          self.order.lines.push(res.line)
          self.theForm.$dirty = true
          init()
        })
    }

    function addAmendment () {
      return LineService.promptLineCreate(self.order)
        .then(function (res) {
          self.order.amendments = self.order.amendments || []
          self.order.amendments.push(res.line)
          self.theForm.$dirty = true
          init()
        })
    }

    function editLine (index, action) {
      return LineService.promptLineEdit(self.order, self.order.lines[index].clone(), action)
        .then(function (res) {
          self.order.lines[index] = res.line
          self.theForm.$dirty = true
          init()
        })
    }

    function editAmendment (index, action) {
      return LineService.promptLineEdit(self.order, self.order.amendments[index].clone(), action)
        .then(function (res) {
          self.order.amendments[index] = res.line
          self.theForm.$dirty = true
          init()
        })
    }

    function lineToFlateRate (index) {
      var l = self.order.lines[index]
      l.unit = 'Forfait'
      l.price.amount = l.total
      l.quantity = 1
      self.theForm.$dirty = true
    }

    function addRubric () {
      return $uibModal.open({
        controllerAs: 'rubrics',
        backdrop: 'static',
        bindToController: true,
        resolve: {
          order: function () { return self.order },
          rubrics: function () { return angular.copy(self.order.rubrics) }
        },
        templateUrl: '/app/modules/order/show/templates/add-rubric.template.html',
        controller: 'AddRubricController'
      }).result.then(function (rubrics) {
        //  var existing = _.map(self.order.rubrics, '_id')
        // var returned = _.map(rubrics, '_id')
        // Something has been deleted
        // console.log(_.difference(existing, returned))
        // Something has been added
        // console.log(_.difference(returned, existing))
        self.order.rubrics = rubrics
        self.theForm.$dirty = true
      })
    }

    function getPositionLabel (rubric) {
      return RubricService.getPositionLabel(rubric, self.order.rubrics)
    }

    function getLinesFor (rubric) {
      return _.filter(self.order.lines, function (elt, index) {
        elt.index = index
        if (typeof elt.rubric === 'object') return elt.rubric._id === rubric._id
        return elt.rubric === rubric._id
      })
    }

    function addTitle () {
      return $uibModal.open({
        controllerAs: 'addcat',
        bindToController: true,
        resolve: {
          invoice: function () { return self.order },
          line: angular.noop,
          categories: ['CategoryService', function (CategoryService) {
            return CategoryService.getCategories().then((data) => {
              return data.map(category => category.label)
            })
          }]
        },
        templateUrl: '/app/modules/invoice/show/templates/add-category.template.html',
        controller: 'AddCategoryController'
      }).result.then(function (line) {
        self.order.lines = self.order.lines || []
        var i = _.findIndex(self.order.lines, { 'label': line.label })
        if (i < 0) {
          self.order.lines.push(line)
        }
        self.theForm.$dirty = true
        init()
      })
    }

    function editTitle (index) {
      return $uibModal.open({
        controllerAs: 'addcat',
        bindToController: true,
        resolve: {
          invoice: function () { return self.order },
          line: function () { return self.order.lines[index].clone() },
          categories: ['CategoryManager', function (CategoryService) {
            return CategoryService.getCategories().then((data) => {
              return data.map(category => category.label)
            })
          }]
        },
        templateUrl: '/app/modules/invoice/show/templates/add-category.template.html',
        controller: 'AddCategoryController'
      }).result.then(function (line) {
        var i = _.findIndex(self.order.lines, { 'label': line.label })
        if (i >= 0) {
          self.order.lines.splice(index, 1)
        } else {
          self.order.lines[index] = line
        }
        self.theForm.$dirty = true
        init()
      })
    }

    function dropLine (data, to) {
      var from = data.from
      self.order.lines.splice(to, 0, self.order.lines.splice(from, 1)[0])
      self.theForm.$dirty = true
    }

    function saveToOrder (obj) {
      self.order.invoices = self.order.invoices || []
      if (!_.includes(_.map(self.order.invoices, function (elt) { return elt._id }), obj._id)) {
        self.order.invoices.unshift(obj._id)
        self.order.currentInvoice = obj._id
      }
      self.order.save().then(function () {
        SnackService.snack({
          text: 'Facture sauvegardée !',
          delay: 5000
        })
        self.loading = false
        $state.go('order.show', {
          id: self.order._id,
          initParams: {
            tabIndex: self.active,
            objIndex: obj.index,
            obj: obj
          }
        })
        init()
      })
    }

    function save (obj) {
      if (initParams && !angular.equals({}, initParams)) {
        initParams = undefined
        params = undefined
      }
      if (self.selectedForm.$dirty) {
        self.loading = true
        obj.save().then(function () {
          self.selectedForm.$dirty = false
          if (obj.type === 'situation') {
            saveToOrder(obj)
          } else {
            self.selectedForm.$dirty = false
            SnackService.snack({
              text: 'Chantier sauvegardé !',
              delay: 5000
            })
            self.loading = false
            $state.go('order.show', { id: obj._id })
          }
        })
      }
    }

    function removeLine (index) {
      self.order.lines.splice(index, 1)
      self.theForm.$dirty = true
      init()
    }

    function removeAmendment (index) {
      self.order.amendments.splice(index, 1)
      self.theForm.$dirty = true
      init()
    }

    function getOrderNumber () {
      if (!self.order.date) return
      if (self.order.status !== 'draft') {
        return UtilService.getInvoiceNumber(self.order, 'order', self.order.numberFormat)
      }
    }

    function getInvoiceNumber (obj) {
      if (!obj.date) return
      if (obj.status !== 'draft') {
        return UtilService.getInvoiceNumber(obj, 'invoice', obj.numberFormat)
      }
    }

    function sendDunningMail () {
      return $uibModal.open({
        controllerAs: 'sendDunning',
        bindToController: true,
        resolve: {},
        templateUrl: '/app/modules/invoice/show/templates/send-dunning.template.html',
        controller: 'SendDunningController'
      }).result.then(function (result) {
        if (result) {
          SnackService.snack({
            text: 'Chantier passé en état "Relance" !',
            delay: 5000
          })
          switchToStatus('dunning') // TODO: modele de mail de relance ?
        }
      })
    }

    function validate () {
      return $uibModal.open({
        controllerAs: 'valid',
        bindToController: true,
        resolve: {
          objType: function () { return self.selectedObj.type }
        },
        templateUrl: '/app/modules/invoice/show/templates/validate.template.html',
        controller: 'ValidateInvoiceController'
      }).result.then(function (result) {
        if (result) {
          var status = self.selectedObj.type === 'situation' ? 'validated' : 'in_progress'
          var text = self.selectedObj.type === 'situation' ? 'Facture validée !' : 'Chantier validé !'
          SnackService.snack({
            text: text,
            delay: 5000
          })
          switchToStatus(status)
        }
        self.loading = false
      })
    }

    function sendInvoice (obj) {
      return $uibModal.open({
        controllerAs: 'send',
        bindToController: true,
        resolve: {
          obj: function () {
            return obj
          },
          type: function () { return 'invoice' }
        },
        templateUrl: '/app/modules/invoice/show/templates/send-invoice.template.html',
        controller: 'SendInvoiceController'
      }).result.then(function (result) {
        var promises = []
        if (result.mail) {
          var recipients = result.emails.filter(function (email) {
            return email.added
          }).map(function (e) { return { Email: e.email } })
          var url = urls.backend + '/services/pdf/invoice/emails/'
          if (result.mailTemplate) {
            url += result.mailTemplate._id
          }
          promises.push($http.post(url, { invoices: [ self.order._id ], recipients: recipients }))
        }
        if (result.print) {
          // TODO: print
        }
        if (result.status) {
          promises.push(switchToStatus('sent'))
        }
        $q.all(promises).then(function () {
          SnackService.snack({
            text: 'Chantier envoyé !',
            delay: 5000
          })
        })
      })
    }

    function sendLitigationMail () {
      return $uibModal.open({
        controllerAs: 'sendLitigation',
        bindToController: true,
        resolve: {},
        templateUrl: '/app/modules/invoice/show/templates/send-litigation.template.html',
        controller: 'SendLitigationController'
      }).result.then(function (result) {
        if (result) {
          SnackService.snack({
            text: 'Chantier passé en état "Litige" !',
            delay: 5000
          })
          switchToStatus('litigation') // TODO: modele de mail de litige ?
        }
      })
    }

    function makePayment () {
      return $uibModal.open({
        controllerAs: 'makePayment',
        bindToController: true,
        resolve: {
          payment: angular.noop,
          creditNotes: function () {
            var creditNoteQuery = CreditNoteManager
              .query()
              .select(self.selectedObj.client._id, 'client')
              .select(['validated', 'sent', 'partly_paid'], 'status')
              .fields('_id number status balanceDue history payments')
            return CreditNoteManager.count(creditNoteQuery)
          },
          balance: function () { return Math.round(self.selectedObj.balanceDue) },
          invoiceId: function () { return self.selectedObj._id },
          clientId: function () { return self.selectedObj.client._id }
        },
        templateUrl: '/app/modules/invoice/show/templates/make-payment.template.html',
        controller: 'MakePaymentController'
      }).result.then(function (payment) {
        self.selectedObj.payments = self.selectedObj.payments || []
        self.selectedObj.payments.push(payment)
        self.selectedObj.save().then(function () {
          SnackService.snack({
            text: 'Paiement enregistré !',
            delay: 5000
          })
          switchToStatus('partly_paid')
        })
      })
    }

    function modifyPayment (payment, index) {
      if (payment.type === 'credit_note') return
      return $uibModal.open({
        controllerAs: 'makePayment',
        bindToController: true,
        resolve: {
          payment: function () { return angular.copy(payment) },
          balance: function () { return self.selectedObj.balanceDue }
        },
        templateUrl: '/app/modules/invoice/show/templates/modify-payment.template.html',
        controller: 'ModifyPaymentController'
      }).result.then(function (payment) {
        self.selectedObj.payments = self.selectedObj.payments || []
        self.selectedObj.payments[index] = payment
        self.selectedObj.save().then(function () {
          SnackService.snack({
            text: 'Paiement modifié !',
            delay: 5000
          })
          if (self.selectedObj.balanceDue >= 0) {
            payInvoice()
          }
        })
      })
    }

    function payInvoice () {
      return $uibModal.open({
        controllerAs: 'pay',
        bindToController: true,
        resolve: {
          balance: function () { return self.selectedObj.balanceDue },
          objType: function () { return self.selectedObj.type }
        },
        templateUrl: '/app/modules/invoice/show/templates/pay-invoice.template.html',
        controller: 'PayInvoiceController'
      }).result.then(function (result) {
        if (result === true) {
          SnackService.snack({
            text: 'Facture payée !',
            delay: 5000
          })
          self.selectedObj.balanceDue = 0
          switchToStatus('paid')
        } else if (result === 'partly_paid') {
          makePayment()
        }
      })
    }

    function closeOrder () {
      return $uibModal.open({
        controllerAs: 'close',
        bindToController: true,
        resolve: {},
        templateUrl: '/app/modules/order/show/templates/close-order.template.html',
        controller: 'CloseOrderController'
      }).result.then(function (result) {
        if (result) {
          SnackService.snack({
            text: 'Chantier clôturé !',
            delay: 5000
          })
          switchToStatus('terminated')
        }
      })
    }

    function setStatus (status) {
      switch (status) {
        case 'validated':
          validate()
          break
        case 'in_progress':
          validate()
          break
        case 'sent':
          sendInvoice(self.selectedObj)
          break
        case 'partly_paid':
          makePayment()
          break
        case 'paid':
          payInvoice()
          break
        case 'dunning':
          sendDunningMail()
          break
        case 'litigation':
          sendLitigationMail()
          break
        case 'terminated':
          closeOrder()
          break
        default:
          switchToStatus(status)
      }
    }

    function asPdf () {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return 'situation' }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = urls.backend + '/services/pdf/invoice/'
        if (template !== false) {
          url += template._id
        }
        $http.post(url, { invoices: [ self.selectedObj._id ] }).then(
          function (d) {
            SnackService.snack({
              text: 'Facture exportée en PDF !',
              delay: 5000
            })
          })
      })
    }

    /*
    function asCsv () {
      var url = urls.backend + '/services/csv/invoices/'
      $http.post(url, { invoices: [ self.order._id ] }).then(
        function (d) {
          SnackService.snack({
            text: 'Chantier exportée en CSV !',
            delay: 5000
          })
        })
    }

    function asSpreadsheet () {
      var url = urls.backend + '/services/spreadsheet/invoices/'
      $http.post(url, { invoices: [ self.order._id ] }).then(
        function (d) {
          SnackService.snack({
            text: 'Chantier exportée en feuille de calcul !',
            delay: 5000
          })
        })
    } */

    function isValid () {
      return self.selectedObj.status !== 'paid' && self.selectedObj.status !== 'draft'
    }

    function isDraft () {
      return self.selectedObj.status === 'draft'
    }

    function getVatList () {
      return angular.copy(vats)
    }

    function searchBpu (search) {
      if (!self.order.client) {
        return
      }
      var query = BpuManager.query({
        populate: JSON.stringify([
          {
            path: 'client'
          }
        ])
      })
        .select(self.order.client._id, 'client')
        .search(search, 'label')
      return BpuManager.get(query)
        .then(function (data) {
          self.bpus = data.data
          return data.data
        })
    }
  }
})(window.angular, window._, window.moment)
